const localStorageData = {
    STATE: "state"
};

export const loadState = () => {
    try {
        const serializedState = localStorage.getItem(localStorageData.STATE);
        if (serializedState === null) {
            return undefined
        }
        return JSON.parse(serializedState)
    } catch (e) {
        console.warn(e);
        return undefined;
    }
};

export const persistState = async (state) => {
    try{
        localStorage.setItem(localStorageData.STATE, JSON.stringify(state))
    } catch (e) {
        console.warn(e);
    }
};

export const deleteState = () => localStorage.removeItem(localStorageData.STATE);
